import { supabase } from './supabaseClient';

const LAST_ACTIVITY_KEY = 'flowdocs_last_activity_date';

export async function trackDailyActivity(userId: string, accountId?: string) {
  try {
    // Get today's date (YYYY-MM-DD)
    const today = new Date().toISOString().split('T')[0];
    
    // Check if we've already tracked activity today
    const lastActivityDate = localStorage.getItem(LAST_ACTIVITY_KEY);
    if (lastActivityDate === today) {
      return; // Already tracked today
    }
    
    // If no accountId provided, try to get it from the user's account
    if (!accountId) {
      const { data: userAccount } = await supabase
        .from('accounts')
        .select('id')
        .eq('owner_id', userId)
        .single();
      
      if (userAccount) {
        accountId = userAccount.id;
      }
    }

    // Only log if we have both user and account IDs
    if (userId && accountId) {
      const { error } = await supabase
        .from('app_usage_logs')
        .insert({
          user_id: userId,
          account_id: accountId,
          activity_type: 'daily_active',
          created_at: new Date().toISOString(),
          metadata: {
            date: today,
            timestamp: new Date().toISOString(),
            user_agent: navigator.userAgent,
            platform: navigator.platform
          }
        });

      if (error) {
        console.error('Failed to track daily activity:', error);
      } else {
        // Update localStorage to prevent duplicate tracking
        localStorage.setItem(LAST_ACTIVITY_KEY, today);
        console.log('Daily activity tracked successfully');
      }
    }
  } catch (error) {
    console.error('Error tracking daily activity:', error);
  }
}